import React from "react";

export function AboutUsDot({ className }: { className?: string }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <g filter="url(#filter0_di_528_55)">
        <circle cx="12.5" cy="11" r="6" fill="#195AFF" />
        <circle cx="12.5" cy="11" r="7" stroke="#EEF4FF" strokeWidth="2" />
      </g>
      <defs>
        <filter id="filter0_di_528_55" x="0.5" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.352941 0 0 0 0 1 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_528_55" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_528_55" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.433105 0 0 0 0 1 0 0 0 0 0.640967 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_528_55" />
        </filter>
      </defs>
    </svg>
  );
}
